import RebalanceContainer from '@components/containers/rebalance';
import AppLayout from '@layouts/AppLayout';
import type { FC } from 'react';

const Rebalance: FC = () => (
    <AppLayout>
        <RebalanceContainer />
    </AppLayout>
);

export default Rebalance;
